import { Component, OnInit, OnChanges, SimpleChange, Input } from '@angular/core';
import { WebNotification } from '../models/notification'

@Component({
  selector: 'notification-card',
  // templateUrl: './notification-card.component.html',
  template: `<div class="notification" [ngClass]="{sucess: (kind == 'SUCCESS'), info: (kind == 'INFO'), warning: (kind == 'WARNING'), unread: unread}">
      <div class="inside">
        <div class="icon-set" *ngIf="kind">
          <div class="icon"><i class="zmdi" [ngClass]="{'zmdi-check': (kind == 'SUCCESS'), 'zmdi-info-outline': (kind == 'INFO'), 'zmdi-alert-triangle': (kind == 'WARNING')}"></i></div>
        </div>
        <div class="content">
          <h2 *ngIf="this._noti.messageTitle">{{this._noti.messageTitle}}</h2>
          <p>{{this._noti.messageString}}</p>
          <a *ngIf="link && linkTitle != 'Goto Dashboard'" [routerLink]="link" [queryParams]="linkQuery">{{linkTitle}}</a>
          <span class="duration" title="{{ this._noti.sentOn | date :'MMM dd, y hh:mm a' }}">{{this._noti.sentOn | dateFormatPipe:'sort'}}</span>
        </div>
      </div>
    </div>`,
  styleUrls: ['./notification-card.component.scss']
})
export class NotificationCardComponent implements OnInit, OnChanges {

  @Input() unread: boolean
  @Input() notification: WebNotification
  @Input() i: number
  _noti: WebNotification
  kind: string  // SUCCESS / INFO / WARNING
  link: string
  linkQuery: string
  linkTitle: string

  constructor() {
  }

  ngOnInit() {
    this.initConfig()
  }

  initConfig() {
    this._noti = new WebNotification(this.notification)
    switch (this._noti.messageType) {
      case 1:
      case 5:
      case 15:
        this.kind = 'SUCCESS'
        break;

      case 2:
      case 6:
      case 7:
      case 9:
      case 11:
      case 12:
      case 13:
        this.kind = 'WARNING'
        break;

      case 3:
      case 4:
      case 8:
      case 10:
      case 14:
        this.kind = 'INFO'
        break;

      default:
        // code...
        break;
    }

    [this.link, this.linkQuery, this.linkTitle] = this._noti.getLinkAndTitle()
  }

  ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
    // if (changes['i'] != null && changes['i'].isFirstChange() == false) {
    //   console.log('changes > (i) previousValue, currentValue > ', changes['i'].previousValue, changes['i'].currentValue)
    //   this.initConfig()
    // }
    // console.log('changes > ', changes)
  }
}


// WEBPACK FOOTER //
// ./src/app/pages/shared/components/notification/notification-card/notification-card.component.ts